import { ConfigService } from '@axo/config/ConfigService';
import { DateFieldUI } from '@axo/form/feature/form-input/DateField/DateFieldUI';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { RadioFieldUI } from '@axo/form/feature/form-input/RadioField/RadioFieldUI';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useWatch } from 'react-hook-form';
import { useBroker } from '../../../../../hooks/useBroker';
import { Step2Data } from '../../../FormData.fi.types';
import { citizenshipOptions, radioOptions } from '../../config/globals';
import { gridColumns } from '../../config/layouts/grid';
import { PoliticallyInfluentialField } from '../../fields';
import styles from '../../loan.module.scss';
import {
  citizenShipFieldOptions,
  livedInMarketCountrySinceFieldOptions,
} from './config';

export function CitizenFormGroup() {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasPoliticallyInfluential } = ConfigService.get(
    'product-unsecured-loan'
  ).fields[broker];

  const isFinnish = useWatch({ name: 'Frontend/IsFinnish' }) === 'Yes';

  const currentYear = new Date().getFullYear();

  return (
    <>
      <Grid columns={gridColumns}>
        <RadioFieldUI<Step2Data>
          name="Frontend/IsFinnish"
          label={t('IsFinnish.label')}
          data-testid="is-native-input"
          options={radioOptions}
          radioStyle="both"
        />
      </Grid>

      {!isFinnish && (
        <div className={styles.inputGroup} data-grey={true}>
          <Grid columns={gridColumns}>
            <DropdownFieldUI<Step2Data>
              name="LoanApplication/Citizenship"
              label={t('Citizenship.label')}
              data-testid="citizenship-input"
              options={citizenshipOptions}
              {...citizenShipFieldOptions}
            />

            <DateFieldUI<Step2Data>
              name="LoanApplication/LivedInMarketCountrySince"
              label={t('LivedInMarketCountrySince.label')}
              data-testid="lived-in-market-country-since-input"
              yearPlaceholder={t('LivedInMarketCountrySince.placeholder')}
              minYearSuffix={t('LivedInMarketCountrySince.year.suffix')}
              i18n="fi-FI"
              minYear={currentYear - 10}
              maxYear={currentYear}
              latestYearAtTop={true}
              rules={livedInMarketCountrySinceFieldOptions.registerOptions}
              showYearOnly
            />
          </Grid>
        </div>
      )}

      {hasPoliticallyInfluential && <PoliticallyInfluentialField />}
    </>
  );
}
